import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../../web/components-v2/Button';
import { Popover, PopoverContent, PopoverTrigger } from '../../../../web/components-v2/Popover';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';
import { ClockAlertIcon } from '../../../../web/components/svgs/icons/ClockAlertIcon';
import { FollowUpsIcon } from '../../../../web/components/svgs/icons/FollowUpsIcon';
import { InfoIcon } from '../../../../web/components/svgs/icons/InfoIcon';
import { PepperIcon } from '../../../components/svgs/icons/PepperIcon';
import { FollowUpImportance } from '../../../viewModels/queue';
import { pepperColor } from '../followUps';

const { fontFamilies, fontSizes, fontWeights } = THEME.typography;

const SPICE_LEVELS = [FollowUpImportance.High, FollowUpImportance.Medium, FollowUpImportance.Low];

export const FollowUpsLegend: React.FC = () => (
	<Popover>
		<PopoverTrigger asChild>
			<Button type='button' variant='ghost' size='icon' aria-label='What the follow up icons mean'>
				<InfoIcon className={css(styleSheet.triggerIcon)} fillColor='currentColor' />
			</Button>
		</PopoverTrigger>
		<PopoverContent align='start' styles={[styleSheet.content]}>
			<h2 className={css(styleSheet.title)}>What the icons mean</h2>
			<dl className={css(styleSheet.list)}>
				<dt className={css(styleSheet.icons)}>
					<FollowUpsIcon className={css(styleSheet.icon)} fill={THEME.colors.icon.gray} />
				</dt>
				<dd className={css(styleSheet.text)}>
					<strong>Follow up</strong> — the day to call this lead back.
				</dd>
				<dt className={css(styleSheet.icons)}>
					<ClockAlertIcon className={css(styleSheet.icon)} fillColor={THEME.colors.icon.primary} />
				</dt>
				<dd className={css(styleSheet.text)}>
					<strong>Scheduled</strong> — a specific time was set for this call.
				</dd>
				<dt className={css(styleSheet.icons)}>
					{SPICE_LEVELS.map(level => (
						<PepperIcon key={level} className={css(styleSheet.icon)} fillColor={pepperColor(level)} />
					))}
				</dt>
				<dd className={css(styleSheet.text)}>
					<strong>Spice level</strong> — how hot the lead is: high, medium or low. Picked when the follow up is
					scheduled.
				</dd>
			</dl>
		</PopoverContent>
	</Popover>
);

const styleSheet = StyleSheet.create({
	triggerIcon: {
		height: 16,
		width: 16,
	},
	content: {
		maxWidth: 320,
	},
	title: {
		fontFamily: fontFamilies.sora,
		fontSize: fontSizes.sm,
		fontWeight: fontWeights.bold,
		margin: `0 0 ${SPACE[12]}px`,
	},
	list: {
		alignItems: 'flex-start',
		columnGap: `${SPACE[12]}px`,
		display: 'grid',
		gridTemplateColumns: 'auto minmax(0, 1fr)',
		margin: 0,
		rowGap: SPACE[12],
	},
	icons: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[4],
		minHeight: SPACE[20],
	},
	icon: {
		height: 16,
		width: 16,
	},
	text: {
		color: THEME.colors.text.main,
		fontSize: fontSizes.sm,
		lineHeight: `${SPACE[20]}px`,
		margin: 0,
	},
});
